import { StreamQueryQuery, StreamType } from '@/__generated__/graphql.ts';

type StreamLockFields = Pick<
  NonNullable<StreamQueryQuery['stream']>,
  'accessAllowed' | 'customTargetsData' | 'customTargets' | 'streamType'
>;

export const streamPostsLocked = (stream: StreamLockFields, isMe: boolean) =>
  !(isMe || stream.accessAllowed) ||
  Boolean(stream.customTargetsData && !stream.customTargets?.length);

export const streamPostsShowLockCta = (
  stream: StreamLockFields,
  isMe: boolean,
) =>
  streamPostsLocked(stream, isMe) &&
  (Boolean(stream.customTargetsData) ||
    stream.streamType !== StreamType.Public);
